// extracted by mini-css-extract-plugin
module.exports = {"ImgZoom":"ImgZoom_ImgZoom__2fOfp","CloseBtn":"ImgZoom_CloseBtn__1FVtS"};